export default __webpack_public_path__ + "static/media/irish_sport_horse.22a20bc6.jpg";